const sky = {
  sky1: "hsl(205, 45.0%, 8.6%)",
  sky2: "hsl(202, 71.4%, 9.6%)",
  sky3: "hsl(201, 74.6%, 12.2%)",
  sky4: "hsl(201, 77.4%, 14.4%)",
  sky5: "hsl(200, 80.3%, 16.5%)",
  sky6: "hsl(200, 84.1%, 18.9%)",
  sky7: "hsl(199, 90.2%, 22.1%)",
  sky8: "hsl(198, 100%, 26.1%)",
  sky9: "hsl(193, 98.0%, 70.0%)",
  sky10: "hsl(192, 100%, 77.0%)",
  sky11: "hsl(192, 85.0%, 55.8%)",
  sky12: "hsl(198, 98.0%, 95.8%)"
};
export { sky };
//# sourceMappingURL=sky.mjs.map
